import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import BoxTitle from './boxTitle/';
import FinanceVideo from './financeVideo';
import ThinkTank from './thinkTank/';
import Meeting from './meeting/';
import Market from './market/';
import Courier from './courier/';

class RightContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;
        const data = {
            financeVideo: content.financeVideo,
            financeVideoAd: content.financeVideoAd,
        };

        return (
            <div className={styles.col_R}>
                {content.financeVideo && content.financeVideo.length > 0 ? (
                    <React.Fragment>
                        <BoxTitle url="#" title="财经推荐" />
                        <Chip
                            id="55016"
                            type="recommend"
                            title="财经推荐"
                            groupName="正文"
                            position="relative"
                            translate="handleFinanceVideoData"
                            content={data}>
                            <FinanceVideo />
                        </Chip>
                    </React.Fragment>
                ) : (
                    ''
                )}
                <NoSSR onSSR={<div className={styles.box_1} />}>
                    <Ad content={content.asideAd1} styleName={styles.box_1} />
                </NoSSR>
                <div className={styles.box_finance}>
                    <BoxTitle url="#" title="策划 · 智库" />
                    <Chip id="140040" type="struct" title="策划智库" groupName="正文" content={content.planning}>
                        <ThinkTank />
                    </Chip>
                </div>
                <NoSSR onSSR={<div className={styles.box_2} />}>
                    <Ad content={content.asideAd2} styleName={styles.box_2} />
                </NoSSR>
                <div className={styles.meeting}>
                    <BoxTitle url="//finance.ifeng.com/zhuanti/" title="专题 · 会议">
                        <NoSSR onSSR={<div className={styles.meetingAd} />}>
                            <Ad content={content.meetingAd} styleName={styles.meetingAd} />
                        </NoSSR>
                    </BoxTitle>
                    <Chip
                        id="165043"
                        type="recommend"
                        title="专题会议"
                        groupName="正文"
                        translate="handleMeetingData"
                        content={content.meeting}>
                        <Meeting ad={content.meetingListAd} />
                    </Chip>
                </div>
                <div className={styles.ad_box}>
                    <NoSSR onSSR={<div className={styles.box_3} />}>
                        <Ad content={content.asideAd3} styleName={styles.box_3} />
                    </NoSSR>
                    <NoSSR onSSR={<div className={styles.box_4} />}>
                        <Ad content={content.asideAd4} styleName={styles.box_4} />
                    </NoSSR>
                </div>
                <div className={styles.market}>
                    <BoxTitle title="投教学堂">
                        <NoSSR onSSR={<div className={styles.marketAd} />}>
                            <Ad content={content.marketAd} styleName={styles.marketAd} />
                        </NoSSR>
                    </BoxTitle>
                    <NoSSR>
                        <Chip
                            id="10080"
                            type="static"
                            title="投教学堂静态碎片"
                            groupName="正文"
                            position="relative"
                            content={content.market}>
                            <Market />
                        </Chip>
                    </NoSSR>
                </div>
                <NoSSR onSSR={<div className={styles.box_5} />}>
                    <Ad content={content.asideAd5} styleName={styles.box_5} />
                </NoSSR>
                <NoSSR>
                    <Chip
                        id="10082"
                        type="static"
                        title="理财速递静态碎片"
                        groupName="正文"
                        position="relative"
                        content={content.courier}>
                        <Courier ad={content.courierAd} />
                    </Chip>
                </NoSSR>
                <NoSSR onSSR={<div className={styles.box_6} />}>
                    <Ad content={content.asideAd6} styleName={styles.box_6} />
                </NoSSR>
                <NoSSR onSSR={<div className={styles.box_7} />}>
                    <Ad content={content.asideAd7} styleName={styles.box_7} />
                </NoSSR>
            </div>
        );
    }
}

export default RightContent;
